import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import configService from '../../services/config.service'

function MaintenanceCheck() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        if (location.pathname.indexOf('/whitelist') > -1) {
          return
        }

        const result = await configService.getMaintenance()
        if (result && result.isMaintenance) {
          navigate('/maintenance', {
            state: { message: result.message },
          })
        } else if (
          !result.isMaintenance &&
          location.pathname.indexOf('/maintenance') > -1
        ) {
          navigate('/')
        }
      } catch (err) {
        navigate('/maintenance')
      }
    }

    checkMaintenance()
  }, [navigate, location.pathname])

  return null // This component doesn't render anything visible
}

export default MaintenanceCheck
